import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useCurrentUser } from '@/hooks/use-current-user';
import { useUserPermissions } from '@/hooks/use-user-permissions';
import { getAllAccounts } from '@/services/api/accounts';

export const useAccountParamInfo = (selectedAccountId?: string | null) => {
    const router = useRouter();
    const { name: userName } = useCurrentUser();
    const accountId = selectedAccountId || (router.query.account_id as string);
    const { isAllBotsAdmin } = useUserPermissions();

    const { data: allAccounts } = useQuery({
        queryKey: ['allAccounts'],
        queryFn: async () => await getAllAccounts(),
        enabled: isAllBotsAdmin,
        initialData: isAllBotsAdmin ? undefined : [],
    });

    const relatedAccount = allAccounts?.find((x) => x.id == accountId);

    const currentAccount = allAccounts?.find(
        (x) => x.name === userName,
    );

    return {
        accountId,
        isCurrentAccount: !accountId || currentAccount?.id === accountId,
        accountName: relatedAccount?.name,
        isAllBotsAdmin,
    };
};
